import { render } from "./DataCountersTable.vue?vue&type=template&id=a6fcb320"
import script from "./DataCountersTable.vue?vue&type=script&lang=js"
export * from "./DataCountersTable.vue?vue&type=script&lang=js"
script.render = render

export default script